module.exports = __webpack_public_path__ + "img/TConcept.cb4925ea.png";